import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuAction } from '../../../shared.models';

@Component({
    selector: 'liebherr-action-menu-item',
    templateUrl: 'action-menu-item.component.html',
    styleUrls: ['action-menu-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionMenuItemComponent {
    @Input() item?: MenuAction;
    @Input() disabled = false;
    action = new EventEmitter<string>();

    constructor() {}

    onClick() {
        if (!this.disabled && this.item) {
            this.action.emit(this.item?.event);
        }
    }
}
